module.exports = __webpack_public_path__ + "img/renz_img3.144ac004.jpg";